"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = void 0;
var useCache_1 = require("./useCache");
var CONFIG = 'GLOBAL_CONFIG';
var useConfig = function (globalConfig) {
    if (globalConfig === void 0) { globalConfig = null; }
    var _a = (0, useCache_1.useCache)(), setDataToCache = _a.setDataToCache, getDataFromCache = _a.getDataFromCache;
    if (globalConfig) {
        setDataToCache(CONFIG, globalConfig);
    }
    return getDataFromCache(CONFIG);
};
exports.useConfig = useConfig;
